import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { importMemory } from "../../../redux/ducks/memory";
import useTargets from "../../../hook/useTargets";
import TextInput from "../../dumb/TextInput";

const ImportMemory = (props) => {
  const [show, hide, renderModal] = useModal();
  const [d_importMemory, status, error, event] = useStatusThunk(importMemory);
  const [targets, renderButton, renderTargets, setTargets] = useTargets({
    disabled: false, // Pass isUploading to disable the button
  });
  const [sourceColumn, setSourceColumn] = useState(null);
  const [file, setFile] = useState(null);

  event.onSuccess = () => {
    hide();
    setSourceColumn(null);
    setFile(null);
  };

  return (
    <React.Fragment>
      <button
        className={"button button--memory " + props.className}
        onClick={show}
      >
        Import
      </button>
      {renderModal(
        <React.Fragment>
          <div className="group">
            <div className="label">src col</div>
            <TextInput set={setSourceColumn} v={sourceColumn} />
          </div>

          {renderButton()}
          {renderTargets()}

          <div className="group">
            <div className="label">XLSX</div>
            <input
              type="file"
              accept=".xlsx"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </div>

          <div className="group">
            <DisplayError error={error} />
          </div>

          <LoadingButton
            loading={status == "pending"}
            className="button--primary"
            onClick={(e) => {
              d_importMemory({
                memoryID: props.memoryID,
                file,
                sourceColumn,
                targets,
              });
            }}
          >
            Import Memory
          </LoadingButton>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default ImportMemory;
